import Api from "@/api";
const route = "address";

const showAdressOnViaCep = async param => {
  const result = await Api.query(`v1/${route}/${param}/viacep`);
  return result.data;
};

const showStates = async param => {
  const result = await Api.query(`v1/states`, param);
  return result.data;
};

const getAddressOnViacep = async param => {
  const result = await Api.query(`v1/address_search/viacep`, param);
  return result.data;
};

export default {
  showAdressOnViaCep,
  showStates,
  getAddressOnViacep
};
